import { basicInformationReduxAction } from "./basicInformation.action";

const initialState = {
  firstName: null,
  lastName: null,
  country_id: undefined,
  phoneNumber: null,
  phoneCountry: null,
  expected_salary: null,
  ref_checked_values: [],
  ref_other_value: null,
  salary_local_currency: null,
};

function BasicInformationReducer (state = initialState, action) {
  const { type = '', payload = null } = { ...action };
  switch (type) {
    case basicInformationReduxAction.UPDATE_BASIC_INFO_STATE_DATA: {
        return { ...state, ...payload }
    }
    case basicInformationReduxAction.RESET_STATE_DATA: {
        return {...initialState}
    }
    case basicInformationReduxAction.API_REQUEST_SUCCESS:
    case basicInformationReduxAction.API_REQUEST_FAIL:
      return state;
    default:
      return state;
  }
}

export default BasicInformationReducer;
